import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const Row = ({ split, children, gap, nowrap, style }) => {
    const css = Object.assign(Object.assign(Object.assign({}, getDefaultCss(nowrap, gap)), { alignItems: 'flex-start' }), style);
    return _jsx("div", Object.assign({ style: css }, { children: Array.isArray(children)
            ? children.map((c, i) => {
                return _jsx("div", Object.assign({ style: { flexGrow: split[i], flexShrink: split[i], flexBasis: 1 } }, { children: c }), i);
            })
            : children }));
};
export const Right = ({ children, gap, nowrap, style }) => {
    const css = Object.assign(Object.assign(Object.assign({}, getDefaultCss(nowrap, gap)), { justifyContent: 'right' }), style);
    return _jsx("div", Object.assign({ style: css }, { children: Array.isArray(children)
            ? children.map((c, i) => {
                return _jsx("div", { children: c }, i);
            }) : children }));
};
const getDefaultCss = (nowrap, gap) => {
    return {
        display: 'flex',
        flexWrap: nowrap ? 'unset' : 'wrap',
        gap: `${gap || 10}px`,
        justifyContent: 'right',
        alignItems: 'center'
    };
};
